import React from 'react';
import { MessageCircleIcon, SearchIcon, EditIcon, CheckCircleIcon } from 'lucide-react';
export const Process = () => {
  const steps = [{
    name: 'Discovery',
    description: 'We start with a deep dive into your business, audience, and goals to understand what makes your brand unique.',
    icon: MessageCircleIcon
  }, {
    name: 'Research',
    description: 'We analyze your competitors, industry trends, and target audience to craft messaging that stands out.',
    icon: SearchIcon
  }, {
    name: 'Creation',
    description: 'Using proven copywriting frameworks, we develop compelling content tailored to your specific needs and objectives.',
    icon: EditIcon
  }, {
    name: 'Refinement',
    description: 'After your review, we fine-tune the copy until it perfectly captures your voice and achieves your goals.',
    icon: CheckCircleIcon
  }];
  return <section id="process" className="py-12 bg-white" data-id="element-484">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-485">
        <div className="lg:text-center" data-id="element-486">
          <h2 className="text-base text-green-600 font-semibold tracking-wide uppercase" data-id="element-487">
            OUR PROCESS
          </h2>
          <p className="mt-2 text-4xl font-bold mb-4 text-[#2c3e50]" data-id="element-488">
            How We'll Work Together
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-600 lg:mx-auto" data-id="element-489">
            A structured approach to creating copy that connects and converts.
          </p>
        </div>
        <div className="mt-10" data-id="element-490">
          <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-x-6 md:gap-y-10" data-id="element-491">
            {steps.map((step, index) => <div key={step.name} className="relative bg-white p-7 rounded-lg shadow-md transition-transform duration-300 hover:-translate-y-2" data-id="element-492">
                <div className="flex items-center justify-center" data-id="element-493">
                  <div className="flex items-center justify-center h-14 w-14 rounded-full bg-[#16a34a] text-white" data-id="element-494">
                    <span className="font-bold text-xl" data-id="element-495">{index + 1}</span>
                  </div>
                </div>
                <div className="mt-5 text-center" data-id="element-496">
                  <div className="flex items-center justify-center h-12 w-12 mx-auto" data-id="element-497">
                    <step.icon className="h-7 w-7 text-green-600" aria-hidden="true" data-id="element-498" />
                  </div>
                  <p className="text-xl leading-6 font-bold text-gray-900" data-id="element-499">
                    {step.name}
                  </p>
                  <p className="mt-3 text-lg text-gray-500" data-id="element-500">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};